<template>
  <div class="lounge-block">
    <div class="heading-area">
      <h3>
        <a nohref @click="moreInfo = product">{{ shortenName(product.product_name, airport.airport_name) }}</a>
      </h3>
    </div>
    <div class="lounge-wrap">
      <div class="lounge-slider carousel">
        <carousel 
          :perPage="1" 
          :navigationEnabled="true" 
          :paginationEnabled="false" 
        >
          <slide v-for="index in 5" :key="index">
            <div class="carousel-item active">
              <img
                :src="`https://skyparkupload1.s3-eu-west-1.amazonaws.com/products/airportlounge/${product.product_id}/${product.product_id}_${index}.jpg`"
                :alt="`${product.product_name}-${index}`"
                @error="$event.target.src = fallbackImage"
              />
            </div>
          </slide>
        </carousel>
        <span class="more"><a nohref @click="moreInfo = product">{{ $t('airportlounge.results.view_more_info') }} <i class="icon-add"></i></a></span>
      </div>
      <div class="lounge-description">
        <ul class="list list-unstyled">
          <li v-for="(item, key) in product.description" :key="key">
            <i class="icon-check_circle"></i> {{ item }}
          </li>
        </ul>
        <div class="schulde-area">
          <strong class="title">{{ $t('airportlounge.results.opening_hours') }}</strong> - 
          <a nohref v-if="this.product.opening_time.indexOf('iew') > -1" @click="openingTimes">{{ product.opening_time }} - {{ product.closing_time }}</a>
          <p v-else >{{ product.opening_time }} - {{ product.closing_time }}</p>
        </div>
      </div>
    </div>
    <div class="lounge-info">
      <div class="price-detail">
        <strong class="title">{{ $t('airporthotel.results.book_price') }}</strong>
        <div class="wrap" v-if="parseFloat(product.discount) > 0">
          <strong class="price">{{ currency }}{{ parseFloat(product.price).toFixed(2) }}</strong>
          <span class="old-price">{{ currency }}{{ product.full_price }}</span>
        </div>
        <div class="wrap" v-else>
          <strong class="price">{{ currency }}{{ parseFloat(product.price).toFixed(2) }}</strong>
        </div>
      </div>
      <div class="time-info" v-if="parseFloat(product.discount) > 0">
        <span class="save-btn mt-2">
          {{ parseFloat(product.discount_percent) }}% {{ $t('airportparking.results.product.cheaper_saving') }} {{ currency }}{{ product.discount }}
        </span>
      </div>
      <span class="number hotel-room" v-if="product.terminal"><i class="icon-bus"></i>{{ $t('airportlounge.results.terminal') }} {{ product.terminal }}</span>
      <a nohref @click="bookNow" class="btn btn-primary">{{ $t('airportlounge.results.book_now') }}</a>
    </div>
</div>
</template>

<script>
import { get, sync } from "vuex-pathify";
import { Carousel, Slide } from 'vue-carousel';
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";

export default {
  name: "lounge-item",
  mixins: [mixins.validate, mixins.globals, mixins.format], 
  components: { Slide, Carousel },
  props: {
    product: { type: Object, default: () => {}, required: true },
  },
  computed: {
    moreInfo: sync("modals/moreInfo"),
    airport: get("results/airport"),
    salesMessages() {
      return Object.values(this.product.supplier_data.sales_messages).filter(a => a)
    }
  },
  methods: {
    bookNow() {
      eventBus.$emit("SELECTED", this.product);
    },
    openingTimes() {
      this.moreInfo = this.product;
    }
  }
};
</script>